import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Typography } from "@mui/material";
import { CheckCircleOutline, Close, InfoOutlined } from "@mui/icons-material";
import { useState } from "react";
import Tooltip from "../../../Atoms/Tooltip";

type AnticipationModalProps = {
  open: boolean;
  onClose: () => void;
  onContinue: () => void;
};

export const AnticipationModal = ({ open, onClose, onContinue }: AnticipationModalProps) => {
  const [accepted, setAccepted] = useState(false);

  const handleContinue = () => {
    onContinue();
    setAccepted(false);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '16px',
          boxShadow: '0 8px 24px rgba(0,0,0,0.18)'
        }
      }}
      aria-labelledby="anticipation-dialog-title"
      aria-describedby="anticipation-dialog-description"
    >
      <DialogTitle
        id="anticipation-dialog-title"
        sx={{
          bgcolor: 'primary.main',
          color: 'common.white',
          textAlign: 'center',
          py: 2.5,
          fontSize: 22,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: 60,
        }}
      >
        Termos e Condições
      </DialogTitle>
      <DialogContent dividers sx={{ p: 2, pt: 0 }}>
        <Typography id="anticipation-dialog-description" variant="body2" sx={{ mb: 2,mt:2 }}>
          Ao continuar com a solicitação de antecipação, você concorda com os termos estabelecidos pela plataforma,
          incluindo taxas, prazos e condições comerciais previstas no contrato firmado com a empresa.
        </Typography>

        <FormControlLabel
          control={<Checkbox checked={accepted} onChange={e => setAccepted(e.target.checked)} />}
          label={
            <span style={{ display: "inline-flex", alignItems: "center" }}>
              Li e aceito os termos e condições.
              <Tooltip title="Leia com atenção os termos antes de aceitar">
                <InfoOutlined fontSize="small" style={{ marginLeft: 6 }} />
              </Tooltip>
            </span>
          }
        />
      </DialogContent>
      <DialogActions>
        <Tooltip title="Cancelar e voltar para a tela de detalhes e revisar a nota">
          <Button onClick={onClose} color="error" variant="text" startIcon={<Close />}>
            Voltar
          </Button>
        </Tooltip>
        <Tooltip title={accepted ? "Prosseguir com a solicitação" : "Você precisa aceitar os termos"}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleContinue}
            startIcon={<CheckCircleOutline />}
            sx={{ color: "white" }}
            disabled={!accepted}
          >
            Aceitar e Continuar
          </Button>
        </Tooltip>
      </DialogActions>
    </Dialog>
  );
};
